/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setup_Create_PasskeyInputs */

const en_setup_create_passkey = /** @type {(inputs: Setup_Create_PasskeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create passkey`)
};

const de_setup_create_passkey = /** @type {(inputs: Setup_Create_PasskeyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passkey erstellen`)
};

/**
* | output |
* | --- |
* | "Create passkey" |
*
* @param {Setup_Create_PasskeyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const setup_create_passkey = /** @type {((inputs?: Setup_Create_PasskeyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setup_Create_PasskeyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_setup_create_passkey(inputs)
	return en_setup_create_passkey(inputs)
});